import React, { useEffect, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import PropTypes from 'prop-types';
import EmptySig from '../../../assets/empty-state-signature.svg';
import { intl } from '../../../providers/IntlProvider';
import style from './SignaturePad.module.less';

const Signature = ({ setAcceptanceSig, width }) => {
  const [canvasTouched, setCanvasTouched] = useState(false);

  let sigPad = {};

  const clear = () => {
    sigPad.clear();
    setCanvasTouched(false);
    setAcceptanceSig('');
  };

  const onSignatureBegin = () => {
    setCanvasTouched(true);
    if (sigPad) {
      const signatureData = sigPad
        .getCanvas()
        .toDataURL()
        .substring(22);
    }
  };

  const onSignatureEnd = () => {
    if (sigPad) {
      const signatureData = sigPad
        .getCanvas()
        .toDataURL()
        .substring(22);
      setAcceptanceSig(signatureData);
    }
  };

  return (
    <div>
      <div className={style.signaturePad}>
        <SignaturePad
          ref={(ref) => {
            sigPad = ref;
          }}
          canvasProps={{
            width,
            height: 100,
          }}
          onBegin={() => onSignatureBegin()}
          onEnd={() => onSignatureEnd()}
        />
        <div className={style.signatureHelper} data-test="signatureHelper">
          <span>{intl.formatMessage({ id: 'text.pleaseSignHereToConfirmDefect' })}</span>
          {canvasTouched && (
            <button type="button" onClick={() => clear()} className={style.clearButton}>
              {intl.formatMessage({ id: 'form.button.clear' })}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

Signature.propTypes = {
  setAcceptanceSig: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Signature.defaultProps = {
  width: 500,
};

export default Signature;
